export interface DashboardData {
  receivableMonthQuantity: number;
  receivableDayQuantity: number;
  receivableDayValue: number;
  receivableSettledDayQuantity: number;
  receivableSettledDayValue: number;
  receivableExpiredQuantity: number;
  receivableForecastValue: number;
  payableMonthQuantity: number;
  payableDayQuantity: number;
  payableDayValue: number;
  payableSettledDayQuantity: number;
  payableSettledDayValue: number;
  payableExpiredQuantity: number;
  payableForecastValue: number;
  workOrderOpenTotal: number;
  workOrderOpenMonth: number;
  workOrderAuthorizedTotal: number;
  workOrderAuthorizedMonth: number;
  workOrderCancelledMonth: number;
  workOrderCancelledTotal: number;
  workOrderClosedMonth: number;
  workOrderClosedTotal: number;
  averageTicketTotal: number;
  averageTicketMonth: number;
  averageTicketRealMonth: number;
  deliveryMonth: number;
  deliveryExpired: number;
  vehiclesEntryMonth: number;
  vehiclesReturnMonth: number;
}

export enum DashboardType {
  default = 'domain.enums.dashboard_type.default',
  financial = 'domain.enums.dashboard_type.financial',
  management = 'domain.enums.dashboard_type.management',
  workOrder = 'domain.enums.dashboard_type.work_order',
}

export interface DashboardQuick {
  receivableMonthValue: number;
  receivableExpiredValue: number;
  payableMonthValue: number;
  payableExpiredValue: number;
  payableForecastValue: number;
  workOrderOpenMonth: number;
  workOrderAuthorizedMonth: number;
  averageTicketTotal: number;
  averageTicketMonth: number;
  deliveryMonth: number;
  deliveryExpired: number;
}

export interface DashboardQuickParams {
  dashboardType: DashboardType;
}
